import { Box, BoxProps } from "@mui/material";
import { IKeyFigures, IWikifolioDetailProps } from "src/api/server/wf-detail.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { Alpha } from "src/components-mui/pages/detail/key-figures/components/alpha";
import { Beta } from "src/components-mui/pages/detail/key-figures/components/beta";
import { KeyFigureGroup } from "src/components-mui/pages/detail/key-figures/components/key-figure-group";
import { OtherRiskIndicators } from "src/components-mui/pages/detail/key-figures/components/other-risk-indicators";

interface IKeyFiguresProps extends BoxProps {
    keyFigures: IKeyFigures;
    dict: IWikifolioDetailProps["dict"];
}

export const KeyFigures = ({ keyFigures, dict, ...boxProps }: IKeyFiguresProps) => {
    return (
        <Box component="section" {...boxProps}>
            <WfHeading component="h2" fontSize="2xl" sx={{ mb: { xs: 3, sm: 4 } }}>
                {dict.keyfiguresTitle}
            </WfHeading>
            {keyFigures.kpis.map(keyFigureGroup => (
                <Box key={keyFigureGroup.label} sx={{ "&:not(:last-child)": { mb: 5 } }}>
                    <KeyFigureGroup keyFigureGroup={keyFigureGroup} showHeadline={true}></KeyFigureGroup>
                </Box>
            ))}
            <OtherRiskIndicators keyFigureGroups={keyFigures.otherKeyRiskIndicators}></OtherRiskIndicators>
            <Beta betaSection={keyFigures.beta}></Beta>
            {keyFigures.alpha && <Alpha alphaSection={keyFigures.alpha}></Alpha>}
        </Box>
    );
};
